import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { TotalPerClientFilter } from './total-per-client-filter.model';
import { TotalPerMonthFilter } from './total-per-month-filter.model';

export const ALL_YEARS: number = -1;
export const DURATION_PER_YEAR_FILTER_SCHEMA = Object.freeze({
  YEAR: ALL_YEARS, // tax-year
  DURATION: 0,
  CLIENTS: List<TotalPerClientFilter>([]),
  MONTHS: List<TotalPerMonthFilter>([]),
});
const RECORD = generateSchema(DURATION_PER_YEAR_FILTER_SCHEMA);
const KEYS: any = generateKeys(DURATION_PER_YEAR_FILTER_SCHEMA);

export class DurationPerYearFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.MONTHS,
        value: props.get(KEYS.MONTHS)
          ? this.months.map((params) => new TotalPerMonthFilter(params))
          : List<TotalPerMonthFilter>([]),
      },
      {
        key: KEYS.CLIENTS,
        value: props.get(KEYS.CLIENTS)
          ? this.clients.map((params) => new TotalPerClientFilter(params))
          : List<TotalPerClientFilter>([]),
      },
    ]) as DurationPerYearFilter;
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }

  get months(): List<TotalPerMonthFilter> {
    return this.get(KEYS.MONTHS);
  }

  get clients(): List<TotalPerClientFilter> {
    return this.get(KEYS.CLIENTS);
  }

  isAllYears(): boolean {
    return this.year === ALL_YEARS;
  }
}
